import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { normalizeTextFieldValue } from 'utils/prepare-fields';
import { TextField } from './TextField';

RTextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  control: PropTypes.any,
  rules: PropTypes.object,
};

export function RTextField({ label, name, control, rules, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          label={label}
          value={normalizeTextFieldValue(value)}
          onChange={onChange}
          error={!!error}
          helperText={error?.message ?? ''}
          {...rest}
        />
      )}
    />
  );
}
